$(function() {
	//Automatically open tab from url hash
	var hash = window.location.hash;
	hash && $('a[data-toggle=tab][href="' + hash + '"]').tab('show');

	$('a[data-toggle=tab]').click(function (e) {
		$(this).tab('show');
		//var scrollmem = $('body').scrollTop();
		window.location.hash = this.hash;
		//$('html, body').scrollTop(scrollmem);
	});
});